import { Button } from '@wundo/ui';
import { Sparkles } from 'lucide-react';

export interface MeetingRegenerateRowProps {
  /* Whether there is anything to write the document from again. */
  available: boolean;
  generating: boolean;
  failed: boolean;
  labels: { regenerate: string; generating: string; failed: string };
  onRegenerate: () => void;
}

/**
 * The foot of a written document: write it again, and how that is going. Only
 * offered where writing it once was possible: with nothing to build from it
 * could only come back empty and throw away what the user typed.
 */
export function MeetingRegenerateRow({
  available,
  generating,
  failed,
  labels,
  onRegenerate,
}: MeetingRegenerateRowProps) {
  /* No rule across the card when there is nothing to put under it. */
  if (!available && !generating && !failed) return null;

  return (
    <div className='mt-5 flex flex-wrap items-center gap-3 border-t border-fill pt-4'>
      {available && (
        <Button size='sm' variant='ghost' loading={generating} onClick={onRegenerate}>
          {!generating && <Sparkles className='size-4' aria-hidden='true' />}
          {labels.regenerate}
        </Button>
      )}
      {generating && <span className='text-sm text-ink-muted'>{labels.generating}</span>}
      {failed && (
        <span role='alert' className='text-sm text-danger'>
          {labels.failed}
        </span>
      )}
    </div>
  );
}
